/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export type PrescriptionImageParseResponseStatus =
  (typeof PrescriptionImageParseResponseStatus)[keyof typeof PrescriptionImageParseResponseStatus];

export const PrescriptionImageParseResponseStatus = {
  in_progress: "in_progress",
  completed: "completed",
  failed: "failed",
} as const;
